'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Slate = function (_Component) {
  _inherits(Slate, _Component);

  function Slate() {
    _classCallCheck(this, Slate);

    return _possibleConstructorReturn(this, (Slate.__proto__ || Object.getPrototypeOf(Slate)).apply(this, arguments));
  }

  _createClass(Slate, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          basic = _props.basic,
          heading = _props.heading,
          dashed = _props.dashed,
          borderless = _props.borderless,
          fluid = _props.fluid,
          insetted = _props.insetted,
          clickable = _props.clickable,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['basic', 'heading', 'dashed', 'borderless', 'fluid', 'insetted', 'clickable', 'className']);

      var cx = (0, _classnames2.default)({
        basic: basic,
        heading: heading,
        dashed: dashed,
        borderless: borderless,
        fluid: fluid,
        insetted: insetted,
        clickable: clickable
      }, 'slate', className);

      return _react2.default.createElement(_Box2.default, _extends({
        ts: true,
        className: cx
      }, rest));
    }
  }]);

  return Slate;
}(_react.Component);

Slate.displayName = 'Slate';

Slate.propTypes = {
  basic: _propTypes2.default.bool,
  heading: _propTypes2.default.bool,
  dashed: _propTypes2.default.bool,
  borderless: _propTypes2.default.bool,
  fluid: _propTypes2.default.bool,
  insetted: _propTypes2.default.bool,
  clickable: _propTypes2.default.bool
};

exports.default = Slate;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNsYXRlLmpzIl0sIm5hbWVzIjpbIlNsYXRlIiwicHJvcHMiLCJiYXNpYyIsImhlYWRpbmciLCJkYXNoZWQiLCJib3JkZXJsZXNzIiwiZmx1aWQiLCJpbnNldHRlZCIsImNsaWNrYWJsZSIsImNsYXNzTmFtZSIsInJlc3QiLCJjeCIsImRpc3BsYXlOYW1lIiwicHJvcFR5cGVzIiwiYm9vbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7Ozs7Ozs7OztJQUVNQSxLOzs7Ozs7Ozs7Ozs2QkFDSztBQUFBLG1CQVdILEtBQUtDLEtBWEY7QUFBQSxVQUVMQyxLQUZLLFVBRUxBLEtBRks7QUFBQSxVQUdMQyxPQUhLLFVBR0xBLE9BSEs7QUFBQSxVQUlMQyxNQUpLLFVBSUxBLE1BSks7QUFBQSxVQUtMQyxVQUxLLFVBS0xBLFVBTEs7QUFBQSxVQU1MQyxLQU5LLFVBTUxBLEtBTks7QUFBQSxVQU9MQyxRQVBLLFVBT0xBLFFBUEs7QUFBQSxVQVFMQyxTQVJLLFVBUUxBLFNBUks7QUFBQSxVQVNMQyxTQVRLLFVBU0xBLFNBVEs7QUFBQSxVQVVGQyxJQVZFOztBQVlQLFVBQUlDLEtBQUssMEJBQ1A7QUFDRVQsb0JBREY7QUFFRUMsd0JBRkY7QUFHRUMsc0JBSEY7QUFJRUMsOEJBSkY7QUFLRUMsb0JBTEY7QUFNRUMsMEJBTkY7QUFPRUM7QUFQRixPQURPLEVBVVAsT0FWTyxFQVdQQyxTQVhPLENBQVQ7O0FBY0EsYUFDRTtBQUNFLGdCQURGO0FBRUUsbUJBQVdFO0FBRmIsU0FHTUQsSUFITixFQURGO0FBT0Q7Ozs7OztBQUdIVixNQUFNWSxXQUFOLEdBQW9CLE9BQXBCOztBQUVBWixNQUFNYSxTQUFOLEdBQWtCO0FBQ2hCWCxTQUFPLG9CQUFVWSxJQUREO0FBRWhCWCxXQUFTLG9CQUFVVyxJQUZIO0FBR2hCVixVQUFRLG9CQUFVVSxJQUhGO0FBSWhCVCxjQUFZLG9CQUFVUyxJQUpOO0FBS2hCUixTQUFPLG9CQUFVUSxJQUxEO0FBTWhCUCxZQUFVLG9CQUFVTyxJQU5KO0FBT2hCTixhQUFXLG9CQUFVTTtBQVBMLENBQWxCOztrQkFVZWQsSyIsImZpbGUiOiJTbGF0ZS5qcyIsInNvdXJjZVJvb3QiOiJEOlxcUHJvamVjdHNcXHJlYWN0LXRvY2FzXFxzcmMifQ==



//////////////////
// WEBPACK FOOTER
// ../lib/Slate.js
// module id = 575
// module chunks = 0